import React from 'react';
import { Link } from 'react-router-dom';

const ID = 'text-breadcrumb';
export interface TextBreadcrumbProps {
    value: string;
    path: string;
}

const TextBreadcrumb = (props: TextBreadcrumbProps) => {
    return (
        <li
            key={props.value}
            id={ID}
            aria-current='page'>
            <Link
                className={`text-brand-primary cursor-pointer text-sm text-nowrap opacity-60 hover:opacity-100`}
                to={props.path}>
                {props.value}
            </Link>
        </li>
    );
};

export default TextBreadcrumb;
